<template>
  <template v-if="vehicle && displayVariant === 'sidebar'">
    <div class="client-card border client-card--sidebar" :class="cardClasses">
      <div class="client-card__panel client-card__panel--sidebar">
        <div class="client-card__sidebar-title">
          <div
            class="fs-7 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="vehicleTitle"
          >{{ vehicleTitle }}</div>
          <div
            v-if="hasPodftError"
            class="fs-8 text-danger opacity-75"
          >{{ vehicle.podft.message }}</div>
          <div
            v-else
            class="fs-8 text-gray-500"
          >{{ vehicleSidebarLine }}</div>
        </div>
      </div>
    </div>
  </template>

  <template v-else-if="vehicle && displayVariant === 'default'">
    <div class="client-card border" :class="cardClasses">
      <div class="client-card__panel">
        <i
          class="ki-duotone ki-car-2 fs-md-3x fs-5x"
          :class="[
            hasPodftError
              ? 'text-danger'
              : (vehicle.verify ? 'text-primary' : 'text-warning'),
            isBeingVerify ? 'opacity-0' : ''
          ]"
        >
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
          <span class="path6"></span>
        </i>
        <i
          v-if="isBeingVerify"
          class="ki-duotone ki-abstract-33 fs-md-3x fs-5x text-primary verified opacity-50"
        >
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
        <div class="ms-4">
          <div
            class="fs-6 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            :title="vehicleTitle"
          >{{ vehicleTitle }}</div>
          <template v-if="hasPodftError">
            <div class="fs-8 text-danger opacity-75">{{ vehicle.podft.message }}</div>
          </template>
          <template v-else>
            <div v-if="isBeingVerify" class="fs-8 text-primary opacity-75">Проверка документов</div>
            <div v-else class="fs-8 text-gray-400">
              {{ (vehicle.color ?? '') +' '+ (vehicle.mark ?? '')+' '+ (vehicle.model ?? '') +' '+ (vehicle.year ?? '')  }},
              <span class="text-danger opacity-75">{{ vehicle.verify ? 'Каз.учет' : 'Нерезидент' }}</span>
            </div>
          </template>
        </div>
        <div v-if="!changeDisabled" class="card_change">
          <span
            v-if="hasPodftError"
            class="restart-item"
            title="Повторить проверку"
            @click="$emit('retry-verify')"
          >
            <i class="ki-outline ki-arrows-circle fs-3"></i>
          </span>
          <slot name="change"></slot>
        </div>
      </div>
      <slot v-if="!changeDisabled" name="footer"></slot>
    </div>
  </template>

  <template v-else-if="vehicle && displayVariant === 'wide'">
    <div class="client-card client-card--bpm-wide border" :class="cardClasses">
      <div class="client-card__panel client-card__panel--wide">
        <div class="client-card__icon position-relative">
          <i
            class="ki-duotone ki-car-2 fs-md-3x fs-5x"
            :class="[
              hasPodftError
                ? 'text-danger'
                : (vehicle.verify ? 'text-primary' : 'text-warning'),
              isBeingVerify ? 'opacity-0' : ''
            ]"
          >
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
            <span class="path4"></span>
            <span class="path5"></span>
            <span class="path6"></span>
          </i>
          <i
            v-if="isBeingVerify"
            class="ki-duotone ki-abstract-33 fs-md-3x fs-5x text-primary verified opacity-50"
          >
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
        <div
          class="client-card__title fs-6 fw-bolder text-gray-700 line-clamp"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          :title="vehicleTitle"
        >{{ vehicleTitle }}</div>
        <div
          v-if="hasPodftError"
          class="client-card__meta fs-8 text-danger opacity-75"
        >{{ vehicle.podft.message }}</div>
        <div
          v-else-if="isBeingVerify"
          class="client-card__meta fs-8 text-primary opacity-75"
        >Проверка документов</div>
        <div
          v-else
          class="client-card__meta fs-8 text-gray-400"
        >
          {{ (vehicle.color ?? '') +' '+ (vehicle.mark ?? '')+' '+ (vehicle.model ?? '') +' '+ (vehicle.year ?? '')  }},
          <span class="text-danger opacity-75">{{ vehicle.verify ? 'Каз.учет' : 'Нерезидент' }}</span>
        </div>
        <div v-if="!changeDisabled" class="client-card__extras">
          <slot name="footer"></slot>
        </div>
        <div v-if="!changeDisabled" class="client-card__actions card_change">
          <span
            v-if="hasPodftError"
            class="restart-item"
            title="Повторить проверку"
            @click="$emit('retry-verify')"
          >
            <i class="ki-outline ki-arrows-circle fs-3"></i>
          </span>
          <slot name="change"></slot>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
export default {
  name: 'VehicleBpmCard',
  props: {
    vehicle: {
      type: Object,
      default: null
    },
    changeDisabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['sidebar', 'default', 'wide'].includes(value)
    },
    mode: {
      type: [Object, Function],
      required: true
    }
  },
  emits: ['retry-verify'],
  data() {
    return {
      isMobileViewport: false
    }
  },
  computed: {
    displayVariant() {
      if (this.variant === 'wide' && this.isMobileViewport) {
        return 'default'
      }
      return this.variant
    },
    isBeingVerify() {
      const vehicle = this.vehicle
      return !!(vehicle && vehicle.beingVerify)
    },
    hasPodftError() {
      const podft = this.vehicle && this.vehicle.podft
      return !!(podft && podft.success === false)
    },
    cardClasses() {
      const isSidebar = this.displayVariant === 'sidebar'
      return [
        isSidebar ? 'client-card--sidebar' : '',
        this.isBeingVerify ? 'pulse' : '',
        !isSidebar && this.hasPodftError ? 'border-danger' : ''
      ]
    },
    vehicleSidebarLine() {
      const parts = [(this.vehicle.mark ?? ''), (this.vehicle.model ?? ''), (this.vehicle.year ?? '')].filter(Boolean)
      return parts.join(' · ')
    },
    vehicleTitle() {
      return this.vehicle.number ?? this.vehicle.vin
    }
  },
  mounted() {
    this.mobileMediaQuery = window.matchMedia('(max-width: 767.98px)')
    this.isMobileViewport = this.mobileMediaQuery.matches
    this.onMobileViewportChange = (event) => {
      this.isMobileViewport = event.matches
    }
    this.mobileMediaQuery.addEventListener('change', this.onMobileViewportChange)
  },
  beforeUnmount() {
    this.mobileMediaQuery?.removeEventListener('change', this.onMobileViewportChange)
  }
}
</script>
